enum XHRStates {
  REQ_SEND = 0,
  REQ_RECV = 1,
  REQ_RECV_POLL = 2,
  REQ_RECV_STREAM = 3,
}

export default XHRStates;
